export default "__VITE_ASSET__cd107932__"